import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-alert-text',
  templateUrl: './alert-text.component.html',
  styleUrls: ['./alert-text.component.scss'],
})
export class AlertTextComponent {
  @Input() type: string;
  @Input() view: boolean = true;
  @Input() text: string;
  @Output() viewChange = new EventEmitter<boolean>();
  constructor() {
    this.view = true
  }

  close() {
    this.viewChange.emit(false)
    this.view = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/alert-text/alert-text.component.ts